import React from "react";
import * as cl from "./CourseInfo.module.scss";
import StudySVG from "../SVG/ScientistHatSVG";
import CalendarSVG from "../SVG/CalendarSVG";
import GoalSVG from "../SVG/GoalSVG";
import CourseProgress from "../CourseProgress";
import img from "../images/about_course.png";

const CourseInfo = ({
  meta,
  list,
  isShowProgress,
  currentBlockName,
  changeSelect,
  progressInPercent,
  locked,
}) => {
  const icons = {
    study: <StudySVG />,
    calendar: <CalendarSVG color="#F3A60D" />,
    challenges: <GoalSVG />,
  };

  const getIcon = (iconName) => icons[iconName] || Object.values(icons)[0];

  return (
    <aside className={cl.wrapper}>
      {meta.poster && (
        <img
          src={meta.poster}
          alt="course cover"
          className={cl.image}
          onError={(event) => (event.target.style.display = "none")}
        />
      )}

      {meta.description && (
        <p
          className={cl.text}
          dangerouslySetInnerHTML={{ __html: meta.description }}
        />
      )}

      {meta.sidebar &&
        meta.sidebar[0] &&
        meta.sidebar.map((item, index) => {
          return (
            <div
              style={{
                gridTemplateColumns: item.icon === "false" && "initial",
              }}
              className={cl.item}
              key={index}
            >
              {item.icon !== "false" ? (
                <i className={cl.item_i}>{getIcon(item.icon)}</i>
              ) : (
                <div style={{ display: "none" }}></div>
              )}
              <div className={cl.item_description}>
                <h3 className={cl.item__title}>{item.title}</h3>
                <div
                  className={cl.item__text}
                  dangerouslySetInnerHTML={{ __html: item.description }}
                />
                {isShowProgress && item.type === "navigation" && !locked && (
                  <CourseProgress
                    list={list}
                    currentBlockName={currentBlockName}
                    changeSelect={changeSelect}
                    progressInPercent={progressInPercent}
                  />
                )}
              </div>
            </div>
          );
        })}

      {meta.second_description && (
        <p style={{marginTop: '20px'}}
          className={cl.text}
          dangerouslySetInnerHTML={{ __html: meta.second_description }}
        />
      )}

      {meta.skills[0] && (
        <div className={cl.skills}>
          <h3 className={cl.skills__title}>Skill you will gain</h3>
          <div className={cl.skills_group}>
            {meta.skills.map((item, index) => (
              <span className={cl.skills__item} key={index}>
                {item}
              </span>
            ))}
          </div>
        </div>
      )}
    </aside>
  );
};

export default CourseInfo;
